// extracted by mini-css-extract-plugin
export default {"rating":"XA-z","numberOfStars":"YA-z","count":"ZA-z","barGraphSpacing":"_A-z","barGraph":"aB-z"};